import { render, staticRenderFns } from "./AdvancedPagesSidebar.vue?vue&type=template&id=2beba230&scoped=true"
import script from "./AdvancedPagesSidebar.vue?vue&type=script&lang=js"
export * from "./AdvancedPagesSidebar.vue?vue&type=script&lang=js"
import style0 from "./AdvancedPagesSidebar.vue?vue&type=style&index=0&id=2beba230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beba230",
  null
  
)

export default component.exports